/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {},
  rules: [],
  tokens: {
    backgroundColor: '#ffffff',
    borderColor: '#b2b9bf',
    borderRadius: 6,
    borderWidth: 1,
    flex: 1,
    minWidth: null,
    paddingBottom: 8,
    paddingLeft: 12,
    paddingRight: 12,
    paddingTop: 8,
    shadow: null
  }
}
export default theme
